import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import styles from "../css/footer.module.css"
import { css } from "@emotion/core"

const Footer = () => {
    //Query logo
  const { logo, mvIcon, laIcon, bueIcon } = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "CORM.png" }) {
        publicURL
      }
      mvIcon: file(relativePath: { eq: "whatsapp.png" }) {
        publicURL
      }
      bueIcon: file(relativePath: { eq: "email.png" }) {
        publicURL
      }
    }
  `)

  return (
    <footer className={styles.footerBs}>
      <div className="row">
        <div className={`col-md-3 animated fadeInLeft ${styles.footerBrand} `}>
          <Link to="#home">
            <img src={logo.publicURL} alt="Ofaris" width="160" />
          </Link>
          <p css={css`margin-bottom:40px;`}>
            Somos una empresa dedicada a cuidar a nuestros clientes brindándoles una experiencia de conformidad y excelentes resultados.
          </p>
          <p><i className="fa fa-envelope"></i><a href="mailto:serviceyrefrigeracioncorm@gmail.com" css={css`cursor:pointer; text-decoration:none; color:white !important`}>  serviceyrefrigeracioncorm@gmail.com</a></p>
          <p css={css`color:black !important`}>CORM © 2010-2020</p>
        </div>
        <div className={`col-md-3 animated fadeInUp ${styles.footerNav} `} css={css`text-align:center`}>
          <h4>Contacto por Whatsapp</h4>
            <img src={mvIcon.publicURL} alt="Montevideo" width="160" />
            <h4>+54 9 11 4993 0826</h4>
            {/* <h4>ZC 1100</h4> */}
            <h4>CORM</h4>
        </div>
        <div className={`col-md-3 animated fadeInDown ${styles.footerSocial}`} css={css`text-align:center`}>
          <h4>Contacto por Email</h4>
            <img src={bueIcon.publicURL} alt="Buenos Aires" width="160" />
            <h4>serviceyrefrigeracioncorm@gmail.com</h4>
            {/* <h4>ZC 1425</h4> */}
            <h4>CORM</h4>
        </div>        
      </div>
    </footer>
  )
}

export default Footer
